module.exports = __webpack_public_path__ + "img/live.909a79ab.png";